import React from 'react';
import { Toast } from 'prixa-design-kit/dist';
import { PrivacyPolicy } from './PrivacyPolicy';
import { GoogleSignUp } from './GoogleSignUp';
import { SignUpForm } from './SignUpForm';
import { SignUpContext } from './SignUpContext';

const SignUpTab = () => {
  const [isErrorMsg, setError] = React.useState('');

  return (
    <React.Fragment>
      <PrivacyPolicy />
      <div className="prixa-container is-top">
        <SignUpContext.Provider value={{ setError }}>
          <SignUpForm />
        </SignUpContext.Provider>
        <GoogleSignUp />
        <Toast timeout={3000} message={isErrorMsg} variant="danger" show={isErrorMsg !== ''}></Toast>
      </div>
    </React.Fragment>
  );
};

export default SignUpTab;
